import React from 'react';
import useContent from './components/useContent';
import ClientApp from './ClientApp';
import useWindowSize from './components/useWindowSize';
import Gawaine from './components/ByGawaine';

export default function ClientAppDataLoader() {
  const windowSize = useWindowSize();
  const content = useContent('/content.json');
  const path = window.location.pathname.split('/')
  const section = path.length >= 1 ? path[1] : 'home'; 
  const clientNavTracker = 1; //Used in updateApp
  
  return (
    <>
      <ClientApp content={content} section={section} clientNavTracker={clientNavTracker} windowSize={windowSize}/>
      {content && <Gawaine/>}
    </>
    );

}

